/** The agenda frame's chrome. */
export default {
  loadingAgenda: "Loading agenda",
  pullingAgenda: "Pulling today's agenda…",
  nothingScheduled: "Nothing scheduled",
  // Desktop widget
  now: "Now",
  next: "Next",
  nothingAfter: "Nothing after {time}",
} as const;
